"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ProductInfo = require("../ProductInfo");
var _style = require("./style");
var _CheckUserStatus = _interopRequireDefault(require("./components/CheckUserStatus"));
var _MessagePreview = _interopRequireDefault(require("./components/MessagePreview"));
var _StatusDate = _interopRequireDefault(require("./components/StatusDate"));
var _StatusAd = _interopRequireDefault(require("./components/StatusAd"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ChatListItem = function ChatListItem(_ref) {
  var chat = _ref.chat,
    partner = _ref.partner,
    image = _ref.image,
    isSelected = _ref.isSelected,
    index = _ref.index,
    reloadChatList = _ref.reloadChatList;
  var lastMessage = chat.lastMessage,
    lastMessageAt = chat.lastMessageAt,
    seen = chat.seen,
    subject = chat.subject,
    adStatus = chat.adStatus;
  var name = partner.name,
    online = partner.online;
  var status = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckUserStatus["default"], {
    name: name,
    online: online
  });
  var statusDate = /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusDate["default"], {
    status: status,
    lastMessageAt: lastMessageAt,
    chat: chat,
    index: index,
    reloadChatList: reloadChatList
  });
  var messagePreview = /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessagePreview["default"], {
    seen: seen,
    adStatus: adStatus,
    lastMessage: lastMessage
  });
  var statusAd = /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatusAd["default"], {
    subject: subject,
    adStatus: adStatus,
    isSelected: isSelected
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.WrapperChatListItem, {
    status: adStatus,
    isSelected: isSelected,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductInfo.ProductInfo, {
      adStatus: adStatus,
      image: image,
      firstLine: statusDate,
      secondLine: statusAd,
      thirdLine: messagePreview,
      direction: "ltr",
      imageSize: "large"
    })
  });
};
ChatListItem.propTypes = {
  chat: _propTypes["default"].object.isRequired,
  partner: _propTypes["default"].object.isRequired,
  image: _propTypes["default"].string.isRequired,
  isSelected: _propTypes["default"].bool.isRequired,
  index: _propTypes["default"].number.isRequired,
  reloadChatList: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = ChatListItem;